import Color from 'color';

export const learning = '#faab1a';
export const reading = '#ed028c';
export const writing = '#00aeee';
export const oralcommunication = '#803e8c';
export const numeracy = '#40ad49';

export const blue = '#00b0f0';
export const blueDark = Color(blue).darken(0.25).string();
export const blueLight = Color(blue).lighten(0.5).string();
export const blueLightExtra = Color(blue).lighten(1).string();

export const darkBlue = '#002060';
export const darkBlueDark = Color(darkBlue).darken(0.25).string();

export const grey = '#333f50';
export const greyDark = Color(grey).darken(0.5).string();
export const greyLight = Color(grey).lighten(0.5).string();
export const greyLightExtra = Color(grey).lighten(2).string();

export const yellow = '#ffc000';
export const yellowDark = Color(yellow).darken(0.25).string();

export const purple = '#7030a0';
export const purpleDark = Color(purple).darken(0.25).string();

export const pink = '#ff3399';
export const pinkDark = Color(pink).darken(0.25).string();

export const orange = '#ff8400';
export const orangeDark = Color(orange).darken(0.25).string();

export const green = '#00b050';
export const greenDark = Color(green).darken(0.25).string();

export const red = '#ff0000';
export const redDark = Color(red).darken(0.25).string();

export const backgroundBlue = '#13B3DA';
export const backgroundDarkBlue = '#00307C';
export const backgroundGreen = '#357F2D';
export const backgroundPink = '#F63461';
export const backgroundPurple = '#794391';
export const backgroundYellow = '#FEB850';

export const backgroundLoading = '#00599D';
